module.exports = __webpack_public_path__ + "img/revisao4.36ef52d9.jpg";